import React from 'react';
import './ComingSoon.scss';

/**
 * ComingSoon component - Displays a coming soon message
 * Based on Figma design with heatmap background image
 */
const ComingSoon = () => {
  return (
    <div className="coming-soon-wrapper">
      <div className="coming-soon-overlay" data-node-id="8301:101129">
        <div className="coming-soon-content">
          <h1 className="coming-soon-title">Coming soon!</h1>
          <p className="coming-soon-subtitle">
            HYK is building a new way to explore culture
          </p>
        </div>
      </div>
    </div>
  );
};

export default ComingSoon;
